<template>
  <div>
    <div id="PanelDeAudienciasPendientes_div" class="w-100 px-5 py-4">
      <div id="TituloPanelDeAudienciasPendientes_div">
        <h1>PANEL DE AUDIENCIAS PENDIENTES</h1>
        <h3>Control de audiencias pendientes</h3>
      </div>
      <div class="row d-flex">
        <div class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
          <div class="area">
            <FiltrosDeBusqueda :catalogos="catalogos" :ejecutaLaFuncion="cargaAudienciasPendientes" :filtrosEstablecidos="filtrosEstablecidos"></FiltrosDeBusqueda>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
          <div class="area">
            <h4>Audiencias encontradas</h4>
            <h6>Seleccione la audiencia a trabajar</h6>
            <hr />
            <div id="PanelDeAudienciasPendientesPendientes_table" class="table-responsive">
              <table class="table table-striped table-light table-hover">
                <thead class="thead-dark">
                  <tr>
                    <th class="text-center">Fecha y Hora</th>
                    <th class="text-center">Tipo de Documento</th>
                    <th class="text-center">Consecutivo</th>
                    <th class="text-center">Partido Judicial</th>
                    <th class="text-center">Juzgado</th>
                    <!-- <th class="text-center">Materia</th> -->
                    <th class="text-center">Tipo de Audiencia</th>
                    <th class="text-center">Sala</th>
                    <th class="text-center">Juez</th>
                    <th class="text-center">Operador</th>
                    <th class="text-center">Estatus</th>
                    <th>Auto</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="text-dark">
                  <tr v-if="sesionesDeLasAudienciasPendientes.length <= 0">
                    <td colspan="12" class="text-center">No existen registros de audiencias pendientes</td>
                  </tr>
                  <tr v-else v-for="sesionDeLaAudienciaPendiente in sesionesDeLasAudienciasPendientes" :key="sesionDeLaAudienciaPendiente.SesionDeLaAudienciaId">
                    <td v-html="obtenFechaDeAudienciaConFormato(sesionDeLaAudienciaPendiente.Audiencia.FechaAudiencia)" style="width: 100px;"></td>
                    <td>{{sesionDeLaAudienciaPendiente.Audiencia.TipoDocumento.Nombre}}</td>
                    <td class="text-center">{{sesionDeLaAudienciaPendiente.Audiencia.Consecutivo}}</td>
                    <td>{{sesionDeLaAudienciaPendiente.Audiencia.PartidoJudicial.Nombre}}</td>
                    <td>{{sesionDeLaAudienciaPendiente.Audiencia.Area.Nombre}}</td>
                    <!-- <td>{{sesionDeLaAudienciaPendiente.Audiencia.Materia.Nombre}}</td> -->
                    <td class="text-center">{{sesionDeLaAudienciaPendiente.Audiencia.TipoAudiencia.Nombre}}</td>
                    <td>{{sesionDeLaAudienciaPendiente.Sala.Nombre}}</td>
                    <td>
                      <ul v-if="sesionDeLaAudienciaPendiente.Audiencia.JuecesEnAudiencia.length > 0">
                        <li v-for="juezEnAudiencia in sesionDeLaAudienciaPendiente.Audiencia.JuecesEnAudiencia">
                          {{juezEnAudiencia.Juez.Nombre}}{{juezEnAudiencia.Juez.ApellidoPaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoPaterno : ""}}{{juezEnAudiencia.Juez.ApellidoMaterno != "" ? " " + juezEnAudiencia.Juez.ApellidoMaterno : ""}}
                        </li>
                      </ul>
                      <p v-else>Sin jueces</p>
                    </td>
                    <td>{{sesionDeLaAudienciaPendiente.Audiencia.Usuario_OperadorDeSala.Nombres}}</td>
                    <td class="text-center">{{sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.Nombre}}
                      <span v-html="obtenRecesoDelaAudienciaConFormato(sesionDeLaAudienciaPendiente.Audiencia.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId, sesionDeLaAudienciaPendiente.Audiencia.RecesoDeLaAudiencia)"></span>
                    </td> 
                    <td class="text-center">
                      <a v-on:click="verAutoDeApertura(sesionDeLaAudienciaPendiente)" title="Ver auto de apertura">
                        <i class="fas fa-book"></i>
                      </a>
                    </td>                   
                    <td class="text-center">
                      <a v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 1" v-on:click="verificaSiSeIniciaraLaPreparacionDeLaSala(sesionDeLaAudienciaPendiente.SesionDeLaAudienciaId, sesionDeLaAudienciaPendiente.Audiencia.AudienciaId)" title="La audiencia ha sido registrada y esta lista para preparar la sala.">
                        <i class="fas fa-clipboard"></i>
                      </a>
                      <a v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 2 || sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 8" v-on:click="verificaSiSeCambiaraLaSala(sesionDeLaAudienciaPendiente.SesionDeLaAudienciaId, false, sesionDeLaAudienciaPendiente.Audiencia.AudienciaId)" title="La audiencia esta preparada para grabar.">
                        <i class="fas fa-clipboard-check"></i>
                      </a>
                      <a v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 3" v-on:click="verificaSiSeIniciaraLaGrabacionDeLaAudiencia(sesionDeLaAudienciaPendiente.SesionDeLaAudienciaId, true, sesionDeLaAudienciaPendiente.Audiencia.AudienciaId)" title="Se abre la ventana donde esta en proceso la grabación de la audiencia.">
                        <i class="fas fa-video"></i>
                      </a>
                      <i v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 4">{{sesionDeLaAudienciaPendiente.Receso}}</i>
                      <a v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 1 || sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 2" v-on:click="verificaSiSeCreaComoSubidaDeVideo(sesionDeLaAudienciaPendiente.SesionDeLaAudienciaId)" title="La audiencia sera por medio de subida de video.">
                        <i class="fas fa-upload"></i>
                      </a>
                    </td>
                    <td>
                      <a v-on:click="complementarVideoNVR(sesionDeLaAudienciaPendiente)"  title="Sesión con Videos de fuente 7/24hrs" v-if="sesionDeLaAudienciaPendiente.TipoEstatusDeAudiencia.TipoEstatusDeAudienciaId == 1">
                        <i class="fas fa-film"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visor-documentos-auto">
          <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">Auto de Apertura</h4><br />                        
                <button id="btn-cerrar-visor-documentos-cedula" @click="evtCerrarVisorDocumentoAuto" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
              </div>
              <div class="modal-body">
                <h5>{{sesionSeleccionada.Audiencia.TipoAudiencia.Nombre}} </h5>
                <h5>{{sesionSeleccionada.Audiencia.Consecutivo}} {{sesionSeleccionada.Audiencia.TipoDocumento.Nombre}}</h5><br/>                                                
                <div v-if="sesionSeleccionada.RutaDeAuto != ''" :key="'visorDeAuto_div' + contRenderVisorAuto">                          
                  <PDFDocument                             
                    :url="sesionSeleccionada.RutaDeAuto" 
                    :height="'600px'"
                    :key="'visorDeAuto' + contRenderVisorAuto"
                  />
                </div>
                <div v-else>
                  <h5>No hay registro de auto de apertura</h5>
                </div>
              </div>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import sistemas from '@/../static/js/sistemas'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import router from '@/router/index'
  import axios from 'axios'
  import PDFDocument from '@/../src/components/Comunes/PDFDocument'
  import { mapActions } from 'vuex'

  export default {
    components: {
      FiltrosDeBusqueda: sistemas.Forseti.FiltrosDeBusqueda,
      PDFDocument
    },
    data() {
      return {
        enumeraciones,
        catalogos: [
          { catalogoId: enumeraciones.catalogos.FechaDeInicio },
          { catalogoId: enumeraciones.catalogos.FechaFinal },
          { catalogoId: enumeraciones.catalogos.TiposEstatusDeLaAudiencia, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Todos },
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Consecutivo },
          { catalogoId: enumeraciones.catalogos.Salas, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione },
          { catalogoId: enumeraciones.catalogos.Jueces, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione }
        ],
        sesionesDeLasAudienciasPendientes: [],
        filtrosEstablecidos:
          { TiposEstatus: [ 1, 2, 3, 4, 5 ] },  
        sesionSeleccionada: {
          Audiencia: {
            Consecutivo: String,
            TipoDocumento: {
              Nombre: String
            },
            TipoAudiencia: {
              Nombre: String
            }
          },
          RutaDeAuto: ''          
        },
        contRenderVisorAuto: 0
      }
    },
    props: {
      Busqueda: {Object, default: null}
    },
    mounted() {
      
      if(this.Busqueda!=null)
      {
        this.cargaAudienciasPendientes();
      }
    },
    methods: {
      verAutoDeApertura: function(sesion){ 
        this.sesionSeleccionada = sesion;
        console.log(this.sesionSeleccionada);

        const parametros = {
          AudienciaId: sesion.Audiencia.AudienciaId,    
          EsPrueba: this.enumeraciones.EsPrueba    
        }
        $('#visor-documentos-auto').modal('show');

        axios.post(
          api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.ObtenerAutoDeApertura,
          parametros,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
          ).then(respuesta => {
            if(respuesta.data.SiHayError){
              console.log(respuesta);
              $('#visor-documentos-auto').modal('hide');
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);              
            } else {              
              this.sesionSeleccionada.RutaDeAuto = respuesta.data.Ruta;
              this.contRenderVisorAuto ++;              
            }
  
            comun.SeEstaCargandoInformacion(false);
          }
          ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            this.sesionesDeLasAudienciasPendientes = [];
          });
      },
      evtCerrarVisorDocumentoAuto: function() {        
         $('#visor-documentos-auto').modal('hide');
      },
      esExtensionDeWord: function(rutaCompleta) { 
        if(rutaCompleta != '' && rutaCompleta != undefined){
        let nombreArchivo = this.obtenerNombreArchivo(rutaCompleta);
        let esArchivoWord = false;
        
          let nombreArray = nombreArchivo.split('.');
          const EXTENSION = nombreArray[nombreArray.length -1].toUpperCase();
          if(EXTENSION == 'DOC' || EXTENSION == 'DOCX') {
            esArchivoWord = true;
          }
        
        return esArchivoWord;
        }
      },
      obtenerNombreArchivo: function(rutaCompleta) {
        let obtenerNombreArchivo = null;        
        
        const RUTA_ARCHIVO = rutaCompleta.split('\\');
        obtenerNombreArchivo = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
        
        return obtenerNombreArchivo;
      },
      obtenFechaDeAudienciaConFormato: function(fechaDeAudiencia) {
        return moment(fechaDeAudiencia).format("DD-MM-YYYY <br /> h:mm a")
      },
      obtenRecesoDelaAudienciaConFormato: function(tipoEstatusDeAudienciaId, recesoDeLaAudiencia) {
        if(tipoEstatusDeAudienciaId == 4) {
          const separacionDelTiempoDeReceso = recesoDeLaAudiencia.split(":");
          let formatoDelReceso = "<br />Receso:";
          if(separacionDelTiempoDeReceso[0] != "00")
            formatoDelReceso += " " + separacionDelTiempoDeReceso[0] + " horas";
          return formatoDelReceso + " " + separacionDelTiempoDeReceso[1] + " minutos";
        }
        return "";
      },
      cargaAudienciasPendientes: function() {
        if(this.validaParametrosBusqueda() || this.Busqueda!=null)
        {
          comun.SeEstaCargandoInformacion(true);
          const parametros = {
            FechaInicial: this.$store.state.Comun_FechaInicial,
            FechaFinal: this.$store.state.Comun_FechaFinal,
            PartidoJudicialId: this.Busqueda!=null? this.Busqueda.PartidoJudicialId : this.$store.state.PJ_Catalogos_009PartidosJudiciales.filtroDeBusqueda_PartidoJudicial,
            MateriaId: this.Busqueda!=null? this.Busqueda.MateriaId : this.$store.state.PJ_Catalogos_002Materias.filtroDeBusqueda_Materia,
            AreaId: this.Busqueda!=null? this.Busqueda.AreaId : this.$store.state.PJ_Catalogos_001Areas.filtroDeBusqueda_Area,
            SalaId: this.Busqueda!=null? this.Busqueda.SalaId : this.$store.state.PJ_Catalogos_020Salas.filtroDeBusqueda_Sala,
            TipoEstatusDeLaAudienciaId: this.$store.state.Forseti_Catalogos_001TiposEstatusDeAudiencia.filtroDeBusqueda_TipoEstatusDeLaAudiencia,
            EsPrueba: this.enumeraciones.EsPrueba
          }
          axios.post(
            api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.ObtenSesionesDeLasAudienciasPendientes,
            parametros,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)            
            ).then(respuesta => {
              if(respuesta.data.SiHayError){
                console.log(respuesta);
                comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                this.sesionesDeLasAudienciasPendientes = [];
              } else {
                this.sesionesDeLasAudienciasPendientes = respuesta.data.SesionesDeLasAudiencias;
              }
              comun.SeEstaCargandoInformacion(false);
              if(this.sesionesDeLasAudienciasPendientes.length== 0)
              {
                comun.mensajeDeAlerta("No hay registros de Audiencias pendientes", null, null);
              }
            }
            ).catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
            comun.SeEstaCargandoInformacion(false);
            this.sesionesDeLasAudienciasPendientes = [];
          });
        }
      },
      verificaSiSeCreaComoSubidaDeVideo: function(sesionDeLaAudienciaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "Esta seleccionando que la audiencia sera realizada fuera del sistema y sera subido después.<br />¿Deseas continuar?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              comun.SeEstaCargandoInformacion(true);

              const parametros = {
                SesionDeLaAudienciaId: sesionDeLaAudienciaId,
                EsPrueba: this.enumeraciones.EsPrueba
              }

              axios.post(
                api.conexion + api.Forseti.sistema.audiencias.audienciaspendientes.FinalizarSesionPorMedioDeHandyCam,
                parametros,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
                ).then(respuesta => {
                  if(respuesta.data.SiHayError){
                    console.log(respuesta);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    this.$store.dispatch('A_ReglasDeRuteo', { aDondeSeRuteaOElError: respuesta.data.Error.MensajeId });
                  } else {
                    comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                  }

                  this.cargaAudienciasPendientes();
                }
                ).catch(excepcion => {
                  console.log(excepcion);
                  comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                  comun.SeEstaCargandoInformacion(false);
                  this.audienciasPendientes = [];
                });
            }
          }
        });
      },
      verificaSiSeIniciaraLaPreparacionDeLaSala: function(sesionDeLaAudienciaId, AudienciaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Iniciar las preparaciones de la sala para la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Iniciar preparaciones'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              router.push({ name: "PreparacionDeSala", params: { SesionDeLaAudienciaId: sesionDeLaAudienciaId, AudienciaId: AudienciaId } });
            }
          }
        });
      },
      verificaSiSeCambiaraLaSala: function(sesionDeLaAudienciaId, laGrabacionHaSidoIniciada, audienciaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: "¿Habrá un cambio de sala?<br />Si es así, se le redirigirá a la preparación de la sala para la audiencia.",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Cambiar sala y preparar'
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              router.push({ name: "PreparacionDeSala", params: { SesionDeLaAudienciaId: sesionDeLaAudienciaId, AudienciaId: audienciaId } });
            } else {
              if(laGrabacionHaSidoIniciada != null)
                this.verificaSiSeIniciaraLaGrabacionDeLaAudiencia(sesionDeLaAudienciaId, laGrabacionHaSidoIniciada, audienciaId)
            }
          }
        });
      },
      verificaSiSeIniciaraLaGrabacionDeLaAudiencia: function(sesionDeLaAudienciaId, laGrabacionHaSidoIniciada, audienciaId) {
        bootbox.confirm({
          title: "Mensaje del sistema",
          message: laGrabacionHaSidoIniciada ? "Actualmente se esta grabando la sesión de la audiencia<br />¿Entrar de todos modos?" : "¿Iniciar la preparación de la grabación de la audiencia?",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + (laGrabacionHaSidoIniciada ? 'Entrar' : 'Iniciar grabación')
            }
          },
          callback: (respuesta) => {
            if (respuesta) {
              router.push({ name: "Grabacion", params: { SesionDeLaAudienciaId: sesionDeLaAudienciaId, AudienciaId: audienciaId } });
            }
          }
        });
      },
      validaParametrosBusqueda(){
        
        if(this.$store.state.PJ_Catalogos_009PartidosJudiciales['filtroDeBusqueda_PartidoJudicial'] == -1 && this.Busqueda ==null)
        {
          comun.mensajeDeAlerta("Seleccione un Partido Judicial.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_002Materias['filtroDeBusqueda_Materia'] == -1 && this.Busqueda ==null)
        {
          comun.mensajeDeAlerta("Seleccione una Materia.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_001Areas['filtroDeBusqueda_Area'] == -1 && this.Busqueda ==null)
        {
          comun.mensajeDeAlerta("Seleccione un Juzgado.", null, null);
          return false
        };
        if(this.$store.state.PJ_Catalogos_020Salas['filtroDeBusqueda_Sala'] == -1 && this.Busqueda ==null)
        {
          comun.mensajeDeAlerta("Seleccione una Sala.", null, null);
          return false
        };

        return true;
      },
      complementarVideoNVR: function (datos){
        router.push({ name: "ComplementacionVideo", params:{SesionId: datos.SesionDeLaAudienciaId} });
      }
    }
  }
</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }

  #visor-documentos-auto .modal-lg {
    max-width: 70% !important;
  }

  .modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;    
  }

  a {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPendientes/PanelDeAudienciasPendientes.vue